export default __webpack_public_path__ + "static/media/hip.8a292304.png";